/**
 * Calls `refetch`, unless a call to it is in flight, in which case calls it once more after that call settles, for all
 * the calls in the meantime. Relay dedupes a request identical to one in flight, so the latter may miss the changes
 * since the former started.
 *
 * Settles like the call of `refetch` that it is served by.
 */
export function serializeRefetches<T>(refetch: () => Promise<T>): () => Promise<T> {
	let inFlight: Promise<T> | undefined;
	let pending: Promise<T> | undefined;

	function start() {
		pending = undefined;
		const promise = refetch();
		inFlight = promise;
		const settle = () => {
			inFlight = undefined;
		};
		promise.then(settle, settle);
		return promise;
	}

	return () => {
		if (!inFlight) {
			return start();
		}
		pending ??= inFlight.then(start, start);
		return pending;
	};
}
